import React from 'react';
import { Link } from 'react-router-dom';
import { FaGraduationCap, FaCheckCircle, FaChalkboardTeacher, FaTools, FaCalendarCheck, FaBolt } from 'react-icons/fa';
import './Services.css';

const TrainingService = () => {
  const features = [
    'Professional audio system operation training',
    'Technical training for maintenance staff',
    'Equipment troubleshooting workshops',
    'Preventive maintenance programs',
    'On-site repair and support services',
    'Annual maintenance contracts (AMC)',
    'Emergency support and rapid response',
    'System upgrades and optimization'
  ];

  const benefits = [
    {
      icon: <FaChalkboardTeacher />,
      title: 'Expert Training Programs',
      description: 'Comprehensive training sessions designed to help your team operate and maintain audio systems with confidence.'
    },
    {
      icon: <FaTools />,
      title: 'Reliable Service Support',
      description: 'Professional maintenance and repair services to keep your audio systems running at peak performance year-round.'
    },
    {
      icon: <FaCalendarCheck />,
      title: 'Preventive Maintenance',
      description: 'Regular inspections and maintenance to prevent issues before they occur, minimizing downtime and extending equipment life.'
    },
    {
      icon: <FaBolt />,
      title: 'Rapid Response',
      description: 'Quick turnaround on service calls and repairs to ensure your audio systems are always ready when you need them.'
    }
  ];

  return (
    <div className="service-page">
      {/* Hero Section */}
      <section className="service-hero">
        <div className="service-hero-overlay"></div>
        <div className="service-hero-content">
          <FaGraduationCap className="service-hero-icon" />
          <h1>Training & Service</h1>
          <p>
            Professional training programs and comprehensive service support for all your audio equipment.
            We empower your team with knowledge and provide reliable maintenance services to ensure your
            systems deliver consistent, high-quality performance.
          </p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="container">
          <div className="content-grid">
            <div className="content-text">
              <h2>Training & Support Services</h2>
              <p>
                Investing in professional audio equipment is just the first step. To maximize your investment,
                your team needs proper training on system operation, and your equipment requires regular
                maintenance. We provide comprehensive training programs and service support to ensure your
                audio systems deliver reliable performance for years to come.
              </p>
              <p>
                Our training programs cover everything from basic operation to advanced troubleshooting,
                tailored to your team's needs and technical background. We conduct hands-on sessions at
                your facility, using your actual equipment, so your staff gains practical experience and
                confidence in managing the systems.
              </p>
              <p>
                Our service department offers preventive maintenance programs, emergency repair services,
                and annual maintenance contracts. With decades of combined experience, our certified
                technicians can diagnose and resolve issues quickly, minimizing downtime and keeping your
                audio systems operating at peak performance.
              </p>
            </div>
            <div className="content-image">
              <img 
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=800&h=600&fit=crop&q=80" 
                alt="Training Session" 
              />
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="service-features">
        <div className="container">
          <h2>Our Training & Service Offerings</h2>
          <div className="features-grid">
            {features.map((feature, index) => (
              <div className="feature-item" key={index}>
                <FaCheckCircle />
                <span>{feature}</span>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className="service-benefits">
        <div className="container">
          <div className="section-header">
            <h2>Why Choose Our Training & Service?</h2>
            <p>Professional training and reliable support to maximize your investment</p>
          </div>
          <div className="values-grid">
            {benefits.map((benefit, index) => (
              <div className="value-card" key={index}>
                <div className="value-icon">{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Section */}
      <section className="service-gallery">
        <div className="container">
          <h2>Training & Service in Action</h2>
          <div className="gallery-grid">
            <img src="https://images.unsplash.com/photo-1552664730-d307ca884978?w=600&h=400&fit=crop&q=80" alt="Team Training Session" />
            <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop&q=80" alt="Technical Workshop" />
            <img src="https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=600&h=400&fit=crop&q=80" alt="Equipment Maintenance" />
            <img src="https://images.unsplash.com/photo-1556761175-b413da4baf72?w=600&h=400&fit=crop&q=80" alt="Professional Support" />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="service-cta">
        <div className="container">
          <h2>Need Training or Service Support?</h2>
          <p>Contact us today to schedule training or discuss your maintenance needs</p>
          <div className="cta-buttons">
            <Link to="/contact" className="btn btn-primary">
              Get a Consultation
            </Link>
            <a href="tel:+919876543210" className="btn btn-secondary">
              Call Now
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrainingService;
